import script from "./ChatSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSettings.vue?vue&type=style&index=0&id=4bdad555&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bdad555"]])

export default __exports__